import React, { useState } from "react";
import ReactQuill from "react-quill";

const FreeResponse = ({ setIsEditing, isEditing, question, isMore, index }) => {
  const [value, setValue] = useState("");

  const formats = ["bold", "italic", "underline", "color"];
  return (
    <>
      {isMore ? (
        <div className="mr-tp-bt ">
          <ReactQuill
            theme="snow"
            formats={formats}
            readOnly={!isEditing}
            className={`class-value text-editor-color ${
              isEditing ? "toolbar_fr" : " toolbar_fr_after"
            } ${question.type === "sa" ? "short-ans" : "long-ans"}`}
            placeholder="Response goes here"
          />
          {isEditing && (
            <div className="option-adder-wrapper">
              <div className="Multiplechoice_wrap add_text_save">
                <div
                  className="btn-group"
                  style={{ alignItems: "center" }}></div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsEditing(false)}>
                  Save --{">"}
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default FreeResponse;
